// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "main-static/css/" + chunkId + "." + "3c439ff8" + ".chunk.css";
};